import {Navigate} from 'react-router-dom';
import {isUnattendedTerminal} from 'hooks/terminalMode';
import {usePath} from 'hooks';
import {PATHS} from 'routes/constants';
import {UnattendedWelcomeView} from './UnattendedWelcomeView';

function WelcomeRoute() {
  const isUnattended = isUnattendedTerminal();
  const {getFullPath} = usePath();

  if (isUnattended) {
    return <UnattendedWelcomeView />;
  }

  return <Navigate to={getFullPath(PATHS.searchReservation.main)} replace />;
}

export {WelcomeRoute};
